module.exports = __webpack_public_path__ + "img/skill_level_7_svg.e3d9d650.svg";